import { Text } from '@wix/design-system';
import { useTranslation } from '@wix/wix-i18n-config';
import { FunctionComponent } from 'react';
import { getQuarter } from '../../../../../utils/roadmap';
import { DATA_HOOKS } from '../../../../../dataHooks';
import css from './index.module.scss';

type ETATagProps = {
  eta: number | Long.Long;
};

export const ETATag: FunctionComponent<ETATagProps> = ({ eta }) => {
  const { t } = useTranslation();
  const { quarter, year } = getQuarter(eta);
  return (
    <Text
      dataHook={DATA_HOOKS.SEARCH_RESULT_TAG_ETA}
      textAlign="center"
      size={'tiny'}
      weight="thin"
      className={css.etaText}
    >
      · {t('roadmap.article-item.eta', { quarter, year })} ·
    </Text>
  );
};
